import { render, staticRenderFns } from "./ConstructionHistory.vue?vue&type=template&id=5b5cff08&scoped=true&"
import script from "./ConstructionHistory.vue?vue&type=script&lang=js&"
export * from "./ConstructionHistory.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionHistory.vue?vue&type=style&index=0&id=5b5cff08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5cff08",
  null
  
)

export default component.exports